import React from 'react';
 
import './App.css';
import Relocations from    './Component/Relocations'
function App() {
  return (
    <div className="App">
      <header className="App-header">
         <Relocations></Relocations>
      </header>
    </div>
  );
}

export default App;
